// src/api/index.js - 完整版
import request from '../utils/request';

// 认证相关
export const authApi = {
  login: (data) => request.post('/api/auth/login', data),
  getCurrentUser: () => request.get('/api/auth/me'),
  changePassword: (data) => request.post('/api/auth/change-password', data)
};

// 商品相关
export const productApi = {
  getList: (params) => request.get('/api/products', { params }),
  getDetail: (id) => request.get(`/api/products/${id}`),
  create: (data) => request.post('/api/products', data),
  update: (id, data) => request.put(`/api/products/${id}`, data),
  delete: (id) => request.delete(`/api/products/${id}`),
  getLowStock: () => request.get('/api/products/low-stock/list'),
  getHQStock: () => request.get('/api/products/hq-stock'),
  bulkImport: (data) => request.post('/api/products/bulk-import', data),
  bulkImportMultiSpec: (data) => request.post('/api/products/bulk-import-multispec', data),
};

// 销售相关
export const saleApi = {
  create: (data) => request.post('/api/sales', data),
  getList: (params) => request.get('/api/sales', { params }),
  getDetail: (id) => request.get(`/api/sales/${id}`),
  getPending: () => request.get('/api/sales/pending/list'),
  confirm: (order_no) => request.post(`/api/sales/${order_no}/confirm`),
  cancelSale: (order_no) => request.post(`/api/sales/${order_no}/cancel`),
};

// 班次相关
export const shiftApi = {
  start: (data) => request.post('/api/shifts/start', data),
  end: (data) => request.post('/api/shifts/end', data),
  getCurrent: () => request.get('/api/shifts/current'),
  getHistory: (params) => request.get('/api/shifts/history', { params }),
  getDetail: (id) => request.get(`/api/shifts/${id}`)
};

// 报表相关
export const reportApi = {
  getTodayOverview: () => request.get('/api/reports/today-overview'),
  getSalesStatistics: (params) => request.get('/api/reports/sales-statistics', { params }),
  getTopProducts: (params) => request.get('/api/reports/top-products', { params }),
  getStaffPerformance: (params) => request.get('/api/reports/staff-performance', { params }),
  getSalesReport: (params) => request.get('/api/reports/sales-report', { params }),
  // 新增：配送方式占比 / 支付方式占比 / 运费概览
  getOrderInsights: (params) => request.get('/api/reports/order-insights', { params }),
};

// 用户管理
export const userApi = {
  getList: (params) => request.get('/api/users', { params }),
  create: (data) => request.post('/api/users', data),
  update: (id, data) => request.put(`/api/users/${id}`, data),
  resetPassword: (id, data) => request.post(`/api/users/${id}/reset-password`, data)
};

// 库存管理
export const inventoryApi = {
  adjust: (data) => request.post('/api/products/inventory/adjust', data),
  batchAdjust: (data) => request.post('/api/products/inventory/batch-adjust', data),
  getLogs: (params) => request.get('/api/products/inventory/logs', { params }),
  getProductLogs: (id) => request.get(`/api/products/${id}/inventory/logs`)
};

// 分类管理
export const categoryApi = {
  getList: () => request.get('/api/categories'),
  getDetail: (id) => request.get(`/api/categories/${id}`),
  create: (data) => request.post('/api/categories', data),
  update: (id, data) => request.put(`/api/categories/${id}`, data),
  delete: (id) => request.delete(`/api/categories/${id}`),
  getStats: () => request.get('/api/categories/stats/overview'),
  bulkImport: (data) => request.post('/api/categories/bulk-import', data),
};

// 单位管理
export const unitApi = {
  getList: (params) => request.get('/api/units', { params }),
  getDetail: (id) => request.get(`/api/units/${id}`),
  getStats: () => request.get('/api/units/stats/overview'),
  create: (data) => request.post('/api/units', data),
  update: (id, data) => request.put(`/api/units/${id}`, data),
  delete: (id) => request.delete(`/api/units/${id}`)
};

// 上传管理
export const uploadApi = {
  // 第一步：获取预签名URL
  getUploadUrl: async (file) => {
    const response = await request.post('/api/upload/product-image/sign', {
      filename:    file.name,
      contentType: file.type,
    });
    return response.data;
  },

  // 第二步：直传R2（用XHR避开service worker拦截）
  uploadToR2: (uploadUrl, file) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadUrl, true);
      xhr.setRequestHeader('Content-Type', file.type);

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log('✅ 上传R2成功 status:', xhr.status);
          resolve(xhr);
        } else {
          console.error('❌ R2错误:', xhr.status, xhr.responseText);
          reject(new Error(`上传失败: ${xhr.status}`));
        }
      };

      xhr.onerror = () => {
        console.error('❌ XHR网络错误');
        reject(new Error('网络错误'));
      };

      xhr.send(file);
    });
  },

  // 完整上传流程
  uploadProductImage: async (file) => {
    console.log('🔵 uploadProductImage 开始:', file.name);

    const { upload_url, public_url, key } = await uploadApi.getUploadUrl(file);
    console.log('✅ 获取预签名URL成功:', public_url);

    await uploadApi.uploadToR2(upload_url, file);
    console.log('✅ 上传R2成功');

    return {
      success: true,
      data: {
        url:          public_url,
        key:          key,
        filename:     key,
        originalname: file.name,
        size:         file.size,
        mimetype:     file.type,
      }
    };
  },

  // 删除图片
  deleteProductImage: (key) => {
    console.log('🗑️ deleteProductImage:', key);
    return request.delete('/api/upload/product-image', {
      data: { key }
    });
  }
};

// 门店管理
export const storeApi = {
  getList: () => request.get('/api/stores'),
  getDetail: (id) => request.get(`/api/stores/${id}`),
  create: (data) => request.post('/api/stores', data),
  update: (id, data) => request.put(`/api/stores/${id}`, data),
  getSummary: (params) => request.get('/api/stores/summary', { params })
};

// 库存划拨
export const stockTransferApi = {
  getList: (params) => request.get('/api/stock-transfers', { params }),
  getDetail: (transfer_no) => request.get(`/api/stock-transfers/${transfer_no}`),
  create: (data) => request.post('/api/stock-transfers', data),
  ship: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/ship`),
  receive: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/receive`, data),
  pay: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/pay`, data),
  confirmPayment: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/confirm-payment`),
  cancel: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/cancel`),
  edit: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/edit`, data),
  getLogs: (transfer_no) => request.get(`/api/stock-transfers/${transfer_no}/logs`),
};

// 订单管理（H5订单）
export const ordersManageApi = {
  getList: (params) => request.get('/api/orders', { params }),
  getDetail: (id) => request.get(`/api/orders/${id}`),
  assign: (id, data) => request.put(`/api/orders/${id}/assign`, data),
  confirm: (id) => request.put(`/api/orders/${id}/confirm`),
  prepare: (id) => request.put(`/api/orders/${id}/prepare`),
  deliver: (id) => request.put(`/api/orders/${id}/deliver`),
  complete: (id) => request.put(`/api/orders/${id}/complete`),
  // 新增：确认已退款
  confirmRefund: (id) => request.put(`/api/orders/${id}/confirm-refund`),
  getSettlements: (params) => request.get('/api/orders/settlements', { params })
};

export const shopSettingsApi = {
  getPublicSettings: () => request.get('/api/shop-settings/public'),
  getSettings: () => request.get('/api/shop-settings'),
  updateSettings: (data) => request.put('/api/shop-settings', data),
  getBanners: () => request.get('/api/shop-settings/banners'),
  createBanner: (data) => request.post('/api/shop-settings/banners', data),
  updateBanner: (id, data) => request.put(`/api/shop-settings/banners/${id}`, data),
  deleteBanner: (id) => request.delete(`/api/shop-settings/banners/${id}`)
};

export const customerApi = {
  getList: (params) => request.get('/api/customers', { params }),
  getDetail: (id) => request.get(`/api/customers/${id}`),
  setVip: (id, data) => request.put(`/api/customers/${id}/vip`, data),
  setSuperVip: (id, data) => request.put(`/api/customers/${id}/super-vip`, data),
  getCommissionLogs: (id, params) => request.get(`/api/customers/${id}/commission-logs`, { params }),
  getBalance: (id, params) => request.get(`/api/customers/${id}/balance`, { params }),
  adjustBalance: (id, data) => request.post(`/api/customers/${id}/balance/adjust`, data),
};

// KHQR 支付
export const khqrApi = {
  create: (data) => request.post('/api/khqr/create', data),
  check: (data) => request.post('/api/khqr/check', data),
};

// SKU 规格管理
export const skuApi = {
  getProductSpecs: (product_id) => request.get(`/api/products/${product_id}/specs`),
  saveProductSpecs: (product_id, data) => request.post(`/api/products/${product_id}/specs`, data),
  adjustSkuStock: (sku_id, data) => request.post(`/api/skus/${sku_id}/adjust`, data),
};